<template>
	<div class='category-eidt'>
		<div class='name-wrap'>
      <div class='label'>一级类目名称</div>
      <div class='input-wrap'><input type="text" class="input" placeholder="请输入标题" v-model='name'></div>
    </div>
    <div class='image-wrap'>
  	  <div class="button-wrap">
        <span class="button is-primary" id="js_hotImageUploadBtn">上传图片</span>
        <span>只能上传 jpg/png 文件，且不超过 1MB</span>
      </div>
      <div class="img-wrap" id='hotShotImg'>
        <image-component :image="images.image" :width='250'></image-component>
      </div>
    </div>
    <div class='name-wrap'>
      <div class='label'>添加二级类目</div>
      <div class='selecte-wrap'>
	      <el-select v-model="selectedSecondCategories" multiple filterable placeholder="请选择" class='v-select'>
			    <el-option
			      v-for="item in secondCategories"
			      :key="item.name"
			      :label="item.name"
			      :value="item.name">
			    </el-option>
			  </el-select>
		  </div>
    </div>
    <div class='button-wrap'></div>
	    <el-button type="primary" @click='doSave'>保存</el-button>
	    <el-button @click='back'>返回</el-button>
		  <el-button type="danger" @click='deleteCategory'>删除</el-button>
		</div>
</template>

<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'

export default {
  data () {
    return {
      name: '',
      images: {
        image: '',
        width: '',
        height: ''
      },
      selectedSecondCategories: [],
      secondCategories: []
    }
  },
  mounted () {
    this.getInit()
    this.getSecondCategory()
    this.uploadMainBind()
  },
  methods: {
    getInit () {
      if (this.$route.query.categoryId) {
        HttpRequest.get('/admin.php?method=aicategoryinfo.getAiCategory', {id: this.$route.query.categoryId}).then((response) => {
          this.name = response.data.name
          this.images = response.data.image.image ? response.data.image : this.images
          this.selectedSecondCategories = response.data.secondCategory
        })
      }
    },
    getSecondCategory () {
      HttpRequest.get('/admin.php?method=aicategoryinfo.getAiSecondCategoryList').then((response) => {
        this.secondCategories = response.data.list ? response.data.list : this.secondCategories
      })
    },
    doSave () {
      let params = {
        name: this.name,
        image: this.images,
        secondCategory: this.selectedSecondCategories
      }

      if (!this.name) {
        this.$message('请输入名称')
        return
      }
      if (!this.images.image) {
        this.$message('请上传图片')
        return
      }
      if (this.selectedSecondCategories.length < 1) {
        this.$message('请添加二级菜单')
        return
      }
      if (this.$route.query.categoryId) {
        params.id = this.$route.query.categoryId
      }
      HttpRequest.post('/admin.php?method=aicategoryinfo.doSaveAiCategory', params).then((response) => {
        this.$message('保存成功')
        setTimeout(() => {
          this.$router.push({
	            name: 'category'
	          })
        }, 2000)
      })
    },
    back () {
      this.$router.push({
        name: 'category'
      })
    },
    deleteCategory () {
      if (this.$route.query.categoryId) {
        HttpRequest.post('/admin.php?method=aicategoryinfo.removeByCategory', {categoryId: this.$route.query.categoryId}).then((response) => {
          this.$message('删除成功')
          setTimeout(() => {
            this.$router.push({
		            name: 'category'
		          })
          }, 2000)
        })
      }
    },
		  uploadMainBind () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#js_hotImageUploadBtn',
            multiple: false
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image'
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.images.image = response.data.images.info.path
            this.images.width = response.data.images.info.width
            this.images.height = response.data.images.info.height
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    }
  }
}
</script>

<style lang="less" scoped>
	.image-wrap {
		margin-top: 10px;
	}
	.img-wrap {
		min-height: 300px;
	}
	.selecte-wrap {
		display: flex;
	}
	.v-select {
    flex: 1;
    margin: 0 10px;
  }
  .button-wrap {
  	margin-top: 10px;
  }
</style>
